'use client';
import ProductRating from '@/entities/ProductRating/ui/ProductRating';
// import ProductRating from '@/entities/ProductRating/ui/ProductRating';
import QaTabHeader from '@/entities/QaTabHeader/ui/QaTabHeader';
import { ProductReviews } from '@/features/product-reviews';
import { ReviewsFilter } from '@/features/product-reviews/ui/ProductReviews';
import { IProductCart } from '@/shared/api/getProduct/types';
import { twMergeExt } from '@/shared/utils/twMergeExt';
import { Toggler, TogglerValue } from '@/widgets/product-tabs/ui/ReviewsAndQaTab/Toggler';
import QuestionsItems from '@/widgets/QuestionsItems/ui/QuestionsItems';
import ReviewsItems from '@/widgets/ReviewsItems/ui/ReviewsItems';
// import ReviewsItems from '@/widgets/ReviewsItems/ui/ReviewsItems';
import { cva } from 'class-variance-authority';
import { FC, useState } from 'react';

interface Props {
  className?: string;
  data: IProductCart;
}

export const ReviewsAndQaTab: FC<Props> = ({ className, data }) => {
  const [type, setType] = useState<TogglerValue>('reviews');

  const [reviewsFilter, setReviewsFilter] = useState<ReviewsFilter>({
    type: 'all',
    sort: '',
  });

  return (
    <div className={twMergeExt(cvaRoot(), className)}>
      <div className={cvaHeader()}>
        <Toggler
          value={type}
          reviewsCount={data.reviews?.length || 0}
          questionsCount={data.faq?.length || 0}
          onChange={(e) => setType(e.target.value as TogglerValue)}
        />
        {type === 'reviews' && data.reviews?.length ? (
          <ProductReviews filter={reviewsFilter} onChange={setReviewsFilter} />
        ) : null}
      </div>
      <div className={cvaBody()}>
        <div className={cvaLeft()}>
          {type === 'reviews' ? (
            <ProductRating
              value={data.rating}
              showBtn={data.repeat_buy}
              total={data.reviews?.length}
              details={[
                {
                  rating: '5',
                  total: data.reviews.filter((item) => item.rating === 5)?.length,
                },
                {
                  rating: '4',
                  total: data.reviews.filter((item) => item.rating >= 4 && item.rating < 5)?.length,
                },
                {
                  rating: '3',
                  total: data.reviews.filter((item) => item.rating >= 3 && item.rating < 4)?.length,
                },
                {
                  rating: '2',
                  total: data.reviews.filter((item) => item.rating >= 2 && item.rating < 3)?.length,
                },
                {
                  rating: '1',
                  total: data.reviews.filter((item) => item.rating >= 1 && item.rating < 2)?.length,
                },
              ]}
            />
          ) : null}
          {type === 'questions' ? <QaTabHeader questionsCount={data.faq?.length || 0} /> : null}
        </div>
        <div className={cvaRight()}>
          {type === 'reviews' ? (
            <>
              {data.reviews?.length ? <ReviewsItems items={data.reviews} filter={reviewsFilter} /> : null}
              {!data.reviews?.length && !data.repeat_buy ? (
                <div className={cvaDescr()}>Оформите заказ с этим товаром, чтобы оставить отзыв.</div>
              ) : null}
              {!data.reviews?.length && data.repeat_buy ? (
                <div className={cvaDescr()}>Поделитесь с другими покупателями впечатлениями о товаре.</div>
              ) : null}
            </>
          ) : (
            <>
              {data.faq?.length > 0 ? (
                <QuestionsItems questions={data.faq} />
              ) : (
                <div className={cvaDescr()}>Задайте нам вопрос о товаре, всегда рады помочь!</div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const cvaRoot = cva(['ReviewsAndQaTab-cvaRoot', 'w-full px-2.4 md:px-0']);

const cvaHeader = cva([
  'ReviewsAndQaTab-cvaHeader',
  'grid grid-cols-2 gap-1.6 items-start',
  'border-b border-0.1 border-cBlack border-opacity-[0.16]',
]);

const cvaBody = cva(['ReviewsAndQaTab-cvaBody', 'grid md:grid-cols-2 grid-cols-1 gap-1.6', 'pt-3.2']);

const cvaLeft = cva(['ReviewsAndQaTab-cvaLeft', '']);

const cvaRight = cva(['ReviewsAndQaTab-cvaRight', '']);

export const cvaEmptyTitle = cva(['ReviewsAndQaTab-cvaEmptyTitle', 'text-h3 font-secondary']);

export const cvaDescr = cva(['ReviewsAndQaTab-cvaDescr', 'max-w-[40rem]', 'text-bodyL text-cBlack80']);
